export const DEFAULT_FILTER = (_: string) => true;
export const PROPS_SUPPORTING_COMMENTS = ['background', 'box-shadow', 'text-shadow'];
export const SELECTOR_STATE_REGEX = /.*[^:]:([^:]*)$/;
export const COMMENT_START_IN_RAWS_BETWEEN_REGEX = /^:\s*\/\*/;
